var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Config } from "../../../api/config";
import { createAPI, getByIdAPI, getListAPI, uploadAttachmentAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { getMediaType } from "../../../utils/utils";
import { configurationUrl, PDICheckKeys, pdiCheckPagingUrl, pdiCheckUpsertsUrl, pdiCreateAttachmentUrl, pdiPagingCountUrl, pdiResourceAttachmentUrl, pdiSearchUrl, preCheckQuestionsUrl, saveFilterUrl, selectedSavedFilter, serviceAdvisorListUrl, technicianListUrl, vehicleModelUrl, viewPDIUrl } from "./entity";
var dispatch = store.dispatch;
export var PDIChecPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pdiCheckPagingUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var PDICheckFilterPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.FilterPaging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pdiCheckPagingUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var PDIStatusPagingCountAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PagingCount : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pdiPagingCountUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
        }
    });
}); };
export var SelectedSavedFilterPicklistAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckSavedSelectdFilter : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? selectedSavedFilter : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value];
        }
    });
}); };
export var ServiceAdvisorAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckServiceAdvisor : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? serviceAdvisorListUrl : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value];
        }
    });
}); };
export var TechnicianListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload6, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckTechnician : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? technicianListUrl : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var VehicleListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckVehicleModel : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? vehicleModelUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var SavedFilterAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckSaveFilter : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? saveFilterUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
export var PDICheckCreateAttachmentAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys.PDICheckCreateAttachment : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pdiCreateAttachmentUrl : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
export var genAttachmentURL = function (params) { return "".concat(Config.baseURL, "resource/PreDeliveryCheckAttachment/").concat(params.id); };
export var PDICheckUploadAttachmentAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$data, _createRes$data, _res$payload10, _a, key, _b, request, mediaType, createRequest, createRes, createdAttachmentId, url, res;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckUploadAttachment : _a, _b = params.request, request = _b === void 0 ? {} : _b;
                mediaType = getMediaType(request === null || request === void 0 || (_request$data = request.data) === null || _request$data === void 0 ? void 0 : _request$data.type);
                createRequest = {
                    Attachments: [{
                            MediaType: mediaType,
                            SystemName: 'PDICheckCreateAttachmentAPI'
                        }]
                };
                return [4 /*yield*/, PDICheckCreateAttachmentAPI({
                        request: createRequest
                    })];
            case 1:
                createRes = _c.sent();
                createdAttachmentId = createRes === null || createRes === void 0 || (_createRes$data = createRes.data) === null || _createRes$data === void 0 || (_createRes$data = _createRes$data[0]) === null || _createRes$data === void 0 ? void 0 : _createRes$data.id;
                if (!createdAttachmentId) {
                    throw new Error('Failed to create attachment. No ID returned.');
                }
                url = genAttachmentURL({
                    id: createdAttachmentId
                });
                return [4 /*yield*/, dispatch(uploadAttachmentAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 2:
                res = _c.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.value];
        }
    });
}); };
export var PDICheckResourceAttachmentAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload11, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckUploadAttachment : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pdiResourceAttachmentUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.value];
        }
    });
}); };
export var ViewPDICheckAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload12, _res$payload13, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? viewPDIUrl(request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url
                    }))];
            case 1:
                res = _d.sent();
                console.log('res View PDI : ', res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.value);
                return [2 /*return*/, res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.value];
        }
    });
}); };
export var SearchPDICheckAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload14, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.SearchPDICheck : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pdiSearchUrl(request.Key, request.Value, request.OrganizationId) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload14 = res.payload) === null || _res$payload14 === void 0 ? void 0 : _res$payload14.value];
        }
    });
}); };
export var PDICheckUpsertAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$PreDeliveryD, _res$payload15, _a, key, _b, request, _c, url, data, attachments, payload, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.UpsertPDICheck : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pdiCheckUpsertsUrl : _c;
                console.log('UpsertMobileViewPayload--', request);
                data = request;
                attachments = data === null || data === void 0 ? void 0 : data.Attachments;
                payload = _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.upsertRequest), {}, {
                    Attachments: attachments
                });
                console.log('payload---00--', payload);
                request === null || request === void 0 || (_request$PreDeliveryD = request.PreDeliveryDetail) === null || _request$PreDeliveryD === void 0 || (_request$PreDeliveryD = _request$PreDeliveryD.Questions) === null || _request$PreDeliveryD === void 0 || _request$PreDeliveryD.ActionTaken;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: payload
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.value];
        }
    });
}); };
export var ConfigurationPDICheckAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload16, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ConfigurationPDICheck : _a, _b = params.request, request = _b === void 0 ? {
                    Key: 'PDISettings'
                } : _b, _c = params.url, url = _c === void 0 ? configurationUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload16 = res.payload) === null || _res$payload16 === void 0 ? void 0 : _res$payload16.value];
        }
    });
}); };
export var getAllPDICheckAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _configurationRes$pay, _configurationRes$pay2, _a, key, _b, request, _c, url, configurationReq, viewPDIRes, viewPDICheckData, _ViewPDICheck$payload, _ViewPDICheck$payload2, ViewPDICheck, updatedPreDeliveryDetails, 
    // preCheckQuestionsRes,
    configurationRes, response;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.InpectionQuestionPDICheck : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? preCheckQuestionsUrl : _c;
                // const res = await dispatch(getListAPI({ key: key, url: url, request: request }));
                console.log('GetAll API Fubctions --', request);
                configurationReq = {
                    Key: 'PDISettings'
                };
                viewPDIRes = {
                    id: request === null || request === void 0 ? void 0 : request.id
                };
                viewPDICheckData = {};
                if (!((request === null || request === void 0 ? void 0 : request.Mode) === 'Edit')) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ViewPDICheck,
                        url: viewPDIUrl(viewPDIRes === null || viewPDIRes === void 0 ? void 0 : viewPDIRes.id)
                    }))];
            case 1:
                ViewPDICheck = _d.sent();
                updatedPreDeliveryDetails = ViewPDICheck === null || ViewPDICheck === void 0 || (_ViewPDICheck$payload = ViewPDICheck.payload) === null || _ViewPDICheck$payload === void 0 || (_ViewPDICheck$payload = _ViewPDICheck$payload.value) === null || _ViewPDICheck$payload === void 0 || (_ViewPDICheck$payload = _ViewPDICheck$payload.data) === null || _ViewPDICheck$payload === void 0 ? void 0 : _ViewPDICheck$payload.PreDeliveryDetail.map(function (group) {
                    console.log('groups', group);
                    var groupName = group.QuestionGroupName;
                    // Updated Questions array with injected QuestionGroupName for each question
                    var updatedQuestions = group.Questions.map(function (question) { return _objectSpread(_objectSpread({}, question), {}, {
                        QuestionGroupName: groupName
                    }); });
                    return _objectSpread(_objectSpread({}, group), {}, {
                        Questions: updatedQuestions
                    });
                });
                console.log('updatedPreDeliveryDetails', updatedPreDeliveryDetails);
                // viewPDICheckData = ViewPDICheck?.payload?.value?.data || {};
                viewPDICheckData = _objectSpread(_objectSpread({}, ViewPDICheck === null || ViewPDICheck === void 0 || (_ViewPDICheck$payload2 = ViewPDICheck.payload) === null || _ViewPDICheck$payload2 === void 0 || (_ViewPDICheck$payload2 = _ViewPDICheck$payload2.value) === null || _ViewPDICheck$payload2 === void 0 ? void 0 : _ViewPDICheck$payload2.data), {}, {
                    PreDeliveryDetail: updatedPreDeliveryDetails
                });
                _d.label = 2;
            case 2: return [4 /*yield*/, Promise.all([
                    // dispatch(getListAPI({ key: PDICheckKeys?.InpectionQuestionPDICheck, url: preCheckQuestionsUrl, request: request })),
                    dispatch(getListAPI({
                        key: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ConfigurationPDICheck,
                        url: configurationUrl,
                        request: configurationReq
                    }))
                ])];
            case 3:
                configurationRes = (_d.sent())[0];
                console.log('new configurationRes', configurationRes === null || configurationRes === void 0 || (_configurationRes$pay = configurationRes.payload) === null || _configurationRes$pay === void 0 || (_configurationRes$pay = _configurationRes$pay.value) === null || _configurationRes$pay === void 0 ? void 0 : _configurationRes$pay.data);
                response = _objectSpread(_objectSpread(_objectSpread({}, configurationRes === null || configurationRes === void 0 || (_configurationRes$pay2 = configurationRes.payload) === null || _configurationRes$pay2 === void 0 || (_configurationRes$pay2 = _configurationRes$pay2.value) === null || _configurationRes$pay2 === void 0 ? void 0 : _configurationRes$pay2.data), viewPDICheckData), {}, {
                    statusCode: 200,
                    success: true
                });
                console.log(' New response', response);
                return [2 /*return*/, {
                        success: true,
                        data: _objectSpread({}, response)
                    }];
        }
    });
}); };
export var UploadAttachmentPDICheckAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _params$request, _params$state, _params$request2, _uploadResponse$paylo, _finalResponse$payloa, file, attachments, formatSize, data, payload, _a, key, _b, url, uploadResponse, attachmentData, uploadUrl, finalResponse, uploadedData, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                file = params === null || params === void 0 || (_params$request = params.request) === null || _params$request === void 0 ? void 0 : _params$request.data;
                if (!file || !(file instanceof File || file instanceof Blob)) {
                    console.error("Invalid or missing file in request");
                    return [2 /*return*/, null];
                }
                attachments = params === null || params === void 0 || (_params$state = params.state) === null || _params$state === void 0 ? void 0 : _params$state.Attachments;
                if (!attachments || (attachments === null || attachments === void 0 ? void 0 : attachments.length) === 0) {
                    console.error("No attachments found in params.state.Attachments");
                    return [2 /*return*/, null];
                }
                formatSize = function (bytes) {
                    if (bytes >= 1024 * 1024 * 1024)
                        return "".concat((bytes / (1024 * 1024 * 1024)).toFixed(2), "gb");
                    if (bytes >= 1024 * 1024)
                        return "".concat((bytes / (1024 * 1024)).toFixed(2), "mb");
                    if (bytes >= 1024)
                        return "".concat((bytes / 1024).toFixed(2), "kb");
                    return "".concat(bytes, "b");
                };
                data = params === null || params === void 0 || (_params$request2 = params.request) === null || _params$request2 === void 0 ? void 0 : _params$request2.data;
                payload = {
                    Attachments: [{
                            MediaType: getMediaType(data.type),
                            SystemName: "PreDeliveryCheck",
                            Size: formatSize(data.size),
                            Name: (data === null || data === void 0 ? void 0 : data.name) || "unknown"
                        }]
                };
                _a = params.key, key = _a === void 0 ? PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PDICheckCreateAttachment : _a, _b = params.url, url = _b === void 0 ? pdiCreateAttachmentUrl : _b;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: payload
                    }))];
            case 1:
                uploadResponse = _c.sent();
                attachmentData = uploadResponse === null || uploadResponse === void 0 || (_uploadResponse$paylo = uploadResponse.payload) === null || _uploadResponse$paylo === void 0 || (_uploadResponse$paylo = _uploadResponse$paylo.value) === null || _uploadResponse$paylo === void 0 || (_uploadResponse$paylo = _uploadResponse$paylo.data) === null || _uploadResponse$paylo === void 0 ? void 0 : _uploadResponse$paylo[0];
                if (!(attachmentData !== null && attachmentData !== void 0 && attachmentData.PreDeliveryCheckAttachmentId)) {
                    console.error("Missing PreDeliveryCheckAttachmentId in response", uploadResponse);
                    return [2 /*return*/, null];
                }
                uploadUrl = pdiResourceAttachmentUrl(attachmentData.PreDeliveryCheckAttachmentId);
                console.log("Upload URL:", uploadUrl);
                return [4 /*yield*/, dispatch(uploadAttachmentAPI({
                        key: PDICheckKeys.PDICheckUploadAttachment,
                        request: {
                            data: file,
                            systemname: "PreDeliveryCheckAttachment"
                            // filename: file.name
                        },
                        url: uploadUrl
                    }))];
            case 2:
                finalResponse = _c.sent();
                console.log('finalResponse--', finalResponse);
                uploadedData = finalResponse === null || finalResponse === void 0 || (_finalResponse$payloa = finalResponse.payload) === null || _finalResponse$payloa === void 0 ? void 0 : _finalResponse$payloa.value;
                console.log("Successfully uploaded attachment", uploadedData);
                return [2 /*return*/, uploadedData];
            case 3:
                error_1 = _c.sent();
                console.error("Exception in UploadAttachmentPDICheckAPICall:", error_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
